import type { ReactNode } from 'react';
import { AppLayout, AppHeader, UserAvatarMenu, type NavItem } from '@dhuttu/ui';
import { useAuth } from '../auth/useAuth';

const NAV: NavItem[] = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/warehouses', label: 'Warehouses' },
  { to: '/stores', label: 'Stores' },
  { to: '/members', label: 'Members' },
  { to: '/cashiers', label: 'Cashiers' },
  { to: '/settings', label: 'Settings' },
];

export function MerchantShell({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  return (
    <AppLayout
      header={
        <AppHeader
          title="Dhuttu"
          logoSrc="/brand/logo.png"
          nav={NAV}
          right={
            <UserAvatarMenu
              name={user?.name}
              email={user?.email}
              onSignOut={() => logout()}
            />
          }
        />
      }
    >
      {children}
    </AppLayout>
  );
}
